import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=ccbcc5a2&"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports